import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Typography, Button } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Scrollbars } from "react-custom-scrollbars-2";
import Blood from "./Blood";
import BloodTests from "./BloodTest";
import { Grid as G, CustomLinkBut, ADHImage } from "../../style/Dashboard";
import HorizontalOne from "../../assets/Ads/Horizontal2.jpeg";
import styled from "styled-components";
import { subject } from "../../service";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { verifyAuth } from "../../authverify";
import UpArrow from "../../assets/AssetArrow.png";
import "./checkbox.css";
import Mycontext from "../../store/Mycontext";
import { htmls } from "../../constants";
import Horizontal from "../../assets/Ads/Horizontal.jpeg";
import {
  GridCustom, GridForm
} from "../../style/Procedures";
import { CustomLinkButLink } from "../../style/Button";

const Container = styled.div`
  display: grid;
  grid-template-columns:  100%;
  grid-gap: 0px;
  @media (max-width: 1266px) {
    grid-template-columns: 100%;
  }
  @media (max-width: 866px) {
    grid-template-columns: 100%;
  }
  @media (max-width: 466px) {
    grid-template-columns: 100%;
  }
`;
const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
    "&::-webkit-scrollbar": {
      width: 1,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "darkgrey",
      outline: `1px solid slategrey`,
    },
  },
  paper: {
    border: "0.5px solid #e6e6e6",
    padding: "2px",
    textAlign: "center",
    color: "grey",
    fontWeight: "500",
    maxHeight: 530,
  },
  panel: {
    border: "0.5px solid #e6e6e6",
    width: "100%",
    height: 530,
    fontWeight: "500",
    color: "grey",
    overflowX: "hidden",
  },
  Label: {
    marginTop: 40,
    fontSize: 12,
    color: "gray",
  },
  button: {
    backgroundColor: "#03b3fb",
    borderRadius: 20,
    display: "flex",
    boxShadow: "2px 2px 2px 2px #d9d9d9",
    float: "right",
    color: "white",
    fontWeight: "bold",
    fontFamily: "helvetica",
    textTransform: "none",
    width: 100,
    height: 30,
    fontSize: 15,
    "&:hover": {
      backgroundColor: "#0389fb",
      borderRadius: "20px",
    },
  },
});

class Procedures extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: false
    }
    this.selectedIndex = 1;
    // this.imgsrc = "Ads/Vertical.jpeg";
    this.adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }
  }

  handleListItemClick = (event, index) => {
    this.selectedIndex = index;
  };

  //const imgsrc = "Ads/Vertical1.jpeg";

  componentDidMount = () => {
    this.subscription = subject.subscribe((res) => {
      // this.imgsrc = JSON.parse(res).leftImg;
      // //console.log("Here I am");
      this.setState({ refresh: !this.state.refresh })
    });
  };

  componentWillUnmunt = () => {
    this.subscription.unsubscribe();
  };

  render() {
    const { classes } = this.props;
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    const getRandomReactCreative = () => {
      const withCta = this.adConfig ? this.adConfig.creative_cta === "With CTAs" : null;

      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenReactAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenReactAddWithCTASample;
          return htmls.MedizenRectAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraReactAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraReactAddWithCTARep;
          return htmls.PrimeraReactAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazReactAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazReactAddWithCTASample;
          return htmls.PanazReactAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenReactAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenReactAddWithoutCTARep;
          return htmls.MedizenReactAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraReactAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraReactAddWithoutCTASample;
          return htmls.PrimeraReactAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazReactAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazReactAddWithoutCTARep;
          return htmls.PanazReactAddWithoutCTA;
        }
      }
      return this.props.reactCreative;
    };
    const getRandomVertCreative = () => {
      const withCta = this.adConfig.creative_cta === "With CTAs";

      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenVertAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenVertAddWithCTASample;
          return htmls.MedizenVertAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraVertAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraVertAddWithCTARep;
          return htmls.PrimeraVertAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazVertAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazVertAddWithCTASample;
          return htmls.PanazVertAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenVertAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenVertAddWithoutCTARep;
          return htmls.MedizenVertAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraVertAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraVertAddWithoutCTASample;
          return htmls.PrimeraVertAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazVertAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazVertAddWithoutCTARep;
          return htmls.PanazVertAddWithoutCTA;
        }
      }
      return this.props.verticalCreative;
    };
    return (
      <div className={classes.root}>
        <Container>
          <Grid container>
            <Grid item md={12} lg={`${this.props.verticalCreative ? 9 : 12}`} xs={12}>
              <Grid container>
                <Grid item md={3} xs={12}>
                  <Paper className={classes.paper} id="scrollList">
                    <Typography
                      style={{
                        color: "#4678ED",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "15px",
                        fontSize: "18px",
                        fontWeight: 600,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Laboratory
                      <img
                        src={UpArrow}
                        style={{
                          marginLeft: "auto",
                          marginTop: "7px",
                          width: "15.5px",
                        }}
                      />
                    </Typography>
                    <List
                      style={{
                        position: "relative",
                        overflow: "auto",
                        maxHeight: 472,
                        scrollbarColor: "gray lightgray",
                      }}
                      aria-label="secondary mailbox folder"
                      id="scrollBar"
                    >
                      <ListItem
                        button
                        selected={this.selectedIndex === 1}
                        onClick={(event) => this.handleListItemClick(event, 1)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Blood
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 2}
                        onClick={(event) => this.handleListItemClick(event, 2)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Urine
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 3}
                        onClick={(event) => this.handleListItemClick(event, 3)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Serum
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 4}
                        onClick={(event) => this.handleListItemClick(event, 4)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Stool
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 5}
                        onClick={(event) => this.handleListItemClick(event, 5)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Monotoux
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 6}
                        onClick={(event) => this.handleListItemClick(event, 6)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Pleural
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 7}
                        onClick={(event) => this.handleListItemClick(event, 7)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            CSF
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 8}
                        onClick={(event) => this.handleListItemClick(event, 8)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Tissue
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 9}
                        onClick={(event) => this.handleListItemClick(event, 9)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Scrap
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 10}
                        onClick={(event) => this.handleListItemClick(event, 10)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Asitic Fluid
                          </span>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        selected={this.selectedIndex === 11}
                        onClick={(event) => this.handleListItemClick(event, 11)}
                      >
                        <ListItemText>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily:
                                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                              color: "#58595B",
                            }}
                          >
                            Bronchoscopy Lavage
                          </span>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Paper>
                  {
                    this.props.reactCreative &&
                    <div className="mt-20 mobileCss mobCenter">
                      <div className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px', marginBottom:"20px"}}>
                        <iframe
                          title="iframe"
                          srcDoc={
                            this.props.reactCreative ? getRandomReactCreative() : null
                          }
                          style={{
                            width: '100%',
                            height: '100%',
                            maxWidth: '100%',
                            minHeight: '250px',
                            marginBottom: "30px"
                          }}
                          frameBorder="0"
                          scrolling="no"
                        />
                      </div>
                    </div>
                  }
                </Grid>
                <Grid item md={9} xs={12} className="pl-15 mobPaddLeft15">
                  <GridCustom className={`${this.props.verticalCreative ? "" : "noCreative"}`}>
                    <GridForm>
                      <Paper className={classes.panel}>
                        <Typography
                          style={{
                            color: "#4678ED",
                            paddingTop: 10,
                            paddingLeft: 60,
                            paddingBottom: 10,
                            fontWeight: 600,
                            fontSize: "18px",
                            backgroundColor: "#F9F9F9",
                            fontFamily:
                              "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                          }}
                        >
                          Panels
                        </Typography>
                        <Blood
                          selectedBanner={this.props.selectedBanner}
                          setSelectedBanner={this.props.setSelectedBanner}
                        />
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              color: "#4678ED",
                              paddingTop: 10,
                              paddingLeft: 60,
                              paddingBottom: 10,
                              fontWeight: 600,
                              marginTop: "30px",
                              fontSize: "18px",
                              backgroundColor: "#F9F9F9",
                              fontFamily:
                                "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                            }}
                          >
                            Test
                          </Typography>
                          <BloodTests
                            selectedBanner={this.props.selectedBanner}
                            setSelectedBanner={this.props.setSelectedBanner}
                          />
                        </Grid>
                      </Paper>
                      <Grid item xs={12} className="text-right" style={{ marginTop: "20px" }}>
                        <CustomLinkButLink
                          className="button"
                          style={{ marginBottom: "15px" }}
                          to="/People/Consultation"
                        >
                          Back
                        </CustomLinkButLink>
                        <CustomLinkButLink
                          className="button"
                          style={{ marginBottom: "15px" }}
                          to="/People/Diagnosis"
                        >
                          Next
                        </CustomLinkButLink>
                      </Grid>
                    </GridForm>

                  </GridCustom>
                </Grid>
              </Grid>
            </Grid>
            {
              this.props.verticalCreative &&
              <Grid item md={12} lg={`${this.props.verticalCreative ? 3 : 12}`} xs={12}>
                <div className="text-right mobileCss mobCenter  d-flex justify-content-end">
                  <div  className='responsiveMargin' style={{ maxWidth: '300px', minHeight: '600px', }}>
                    <iframe
                      title="iframe"
                      srcDoc={
                        this.props.verticalCreative ? getRandomVertCreative() : null
                      }
                      style={{
                        width: '100%',
                        height: '100%',
                        maxWidth: '100%',
                        minHeight: '600px',
                        marginBottom: "30px"
                      }}
                      frameBorder="0"
                      scrolling="no"
                    />
                  </div>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div>
    );
  }
}

Procedures.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(Procedures);
